import React, { useMemo } from "react";

import { useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router";

import RouteDrawer, { RouteDrawerProps } from "components/RouteDrawer";
import makeStyles from "hooks/makeStyles";

import CartItemModal from "./CartItemModal";

const useStyles = makeStyles(theme => ({
	root: {},
	paper: {
		borderRadius: `${theme.spacing(2)}px ${theme.spacing(2)}px 0 0`,
		backgroundColor: "rgba(33,33,33,0.7)",
		WebkitBackdropFilter: "blur(5px)",
		backdropFilter: "blur(5px)",
		color: "#fff",
		padding: theme.spacing(2),
		display: "flex",
		height: "calc(var(--vh, 1vh) * 100 - 45px)",
		overflow: "hidden",
		[theme.breakpoints.up(480)]: {
			height: "100vh",
			borderRadius: "0",
			width: "80%",
			maxWidth: "442px",
			left: "auto",
			backgroundColor: theme.palette.background.paper,
			padding: 0,
			color: theme.palette.text.primary
		},
		[theme.breakpoints.up(769)]: {
			width: "50%"
		}
	},
	backdrop: {
		backgroundColor: "rgba(0,0,0,0.1)",
		[theme.breakpoints.up(480)]: {
			backgroundColor: "transparent",
			WebkitBackdropFilter: "blur(1.8px)",
			backdropFilter: "blur(1.8px)"
		}
	},
	closeButton: {
		marginLeft: -2,
		marginTop: -2,
		padding: 0,
		textAlign: "left",
		alignSelf: "flex-start"
	},
	closeIcon: {
		width: 16,
		height: 16,
		color: "#fff"
	},
	title: {
		alignSelf: "flex-start",
		textAlign: "left",
		textTransform: "uppercase",
		marginTop: theme.spacing(2),
		fontWeight: 500,
		fontSize: 16,
		lineHeight: 1,
		letterSpacing: "0.38px"
	}
}));

type Props = Omit<RouteDrawerProps, "swipeable" | "matchRoute">;

const CartItemDrawer = ({ className, ...otherProps }: Props) => {
	const { hash } = useLocation();
	const navigate = useNavigate();
	const classes = useStyles();
	const mobile = useMediaQuery("(max-width:480px)");

	const close = useMemo(
		() => () => {
			if (hash.startsWith("#cart:")) {
				// navigate(-1);
				navigate("#cart");
			}
		},
		[hash, navigate]
	);

	const props: RouteDrawerProps = useMemo(
		() =>
			Object.assign(
				{
					className: clsx(classes.root, className),
					classes: { paper: classes.paper },
					BackdropProps: {
						className: classes.backdrop
					},
					anchor: mobile ? "bottom" : "right",
					disableSwipeToOpen: true,
					swipeable: true,
					matchRoute: ({ location: { hash } }) => hash.startsWith("#cart:"),
					onClose: close,
					onOpen: () => {}
				},
				otherProps
			),
		[className, classes.backdrop, classes.paper, classes.root, close, mobile, otherProps]
	);

	const cartItemLocalId = hash.substr("#cart:".length);

	return (
		<RouteDrawer {...props}>
			<CartItemModal cartItemLocalId={cartItemLocalId} onClose={close} />
		</RouteDrawer>
	);
};

export default CartItemDrawer;
